module.exports = __webpack_public_path__ + "js/0.c50ff3b5.worker.js"